export default __webpack_public_path__ + "static/media/recruiterEmailView.48e4419f.png";